import React from 'react';
import './ErrorPage.css';

const ErrorPage = () => {
  return (
    <div className="error-container">
      <div className="background-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
      </div>

      <div className="error-content">
        <div className="error-header">
          <div className="error-icon">
            <svg className="w-16 h-16 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h1 className="error-title text-gray-900">Access Denied</h1>
          <p className="error-subtitle text-gray-600">
            You cannot access this page directly. Please log in to continue.
          </p>
        </div>

        <div className="error-message">
          <p className="text-red-800">
            This application requires authentication. The root page is not accessible 
            without proper login credentials.
          </p>
        </div>

        <div className="error-footer">
          <p className="footer-text text-gray-500">
            SurveyFlow Pro - Secure Survey Management Platform
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
